export const GET_MACHINERY_APPLICATIONS =
  '/machinery/get_machinery_application';
export const GET_SINGLE_MACHINERY_APPLICATION =
  '/machinery/get_single_machinery_application';
export const CREATE_MACHINERY_APPLICATION =
  '/machinery/create_machinery_application';
export const UPDATE_MACHINERY_APPLICATION =
  '/machinery/update_machinery_application';
export const INQUIRE_MACHINERY_APPLICATION =
  '/machinery/inquire_machinery_application';

export const GET_MACHINERY_APPRAISAL = '/land/get_machinery_appraisal';
export const GET_SINGLE_MACHINERY_APPRAISAL =
  '/land/get_single_machinery_appraisal';
export const CREATE_MACHINERY_APPRAISAL = '/land/create_machinery_appraisal';
export const UPDATE_MACHINERY_APPRAISAL = '/land/update_machinery_appraisal';
export const REMOVE_MACHINERY_APPRAISAL = '/land/remove_machinery_appraisal';

export const GET_MACHINERY_PROPERTY_ASSESSMENT =
  '/land/get_machinery_property_assessment';
export const GET_SINGLE_MACHINERY_PROPERTY_ASSESSMENT =
  '/land/get_single_machinery_property_assessment';
export const CREATE_MACHINERY_PROPERTY_ASSESSMENT =
  '/land/create_machinery_property_assessment';
export const UPDATE_MACHINERY_PROPERTY_ASSESSMENT =
  '/land/update_machinery_property_assessment';
export const REMOVE_MACHINERY_PROPERTY_ASSESSMENT =
  '/land/remove_machinery_property_assessment';

export const GET_MACHINERY_RECORD_OF_SUP_ASSESSMENT =
  '/land/get_machinery_record_of_sup_assessment';
export const GET_SINGLE_MACHINERY_RECORD_OF_SUP_ASSESSMENT =
  '/machinery/get_single_machinery_record_of_sup_assessment';
export const CREATE_MACHINERY_RECORD_OF_SUP_ASSESSMENT =
  '/machinery/create_machinery_record_of_sup_assessment';
export const UPDATE_MACHINERY_RECORD_OF_SUP_ASSESSMENT =
  '/machinery/update_machinery_record_of_sup_assessment';
export const REMOVE_MACHINERY_RECORD_OF_SUP_ASSESSMENT =
  '/machinery/remove_machinery_record_of_sup_assessment';

export const GET_MACHINERY_TRANSACTION = '/machinery/get_machinery_transaction';
export const CREATE_MACHINERY_TRANSACTION =
  '/machinery/create_machinery_transaction';
export const POST_MACHINERY_APPLICATION =
  '/machinery/post_machinery_application';
export const UNPOST_MACHINERY_APPLICATION =
  '/machinery/unpost_machinery_application';
export const REVERT_MACHINERY_APPLICATION =
  '/machinery/revert_machinery_application';

export const GET_LIST_OF_MACHINERY = '/machinery/get_list_of_machinery';

export const GET_LAND_CLASSIFICATIONS = '/land/get_land_classifications';
export const GET_SINGLE_LAND_CLASS = '/land/get_single_land_class';

export const GET_POSTED_LAND_APPLICATION = '/land/get_posted_land_application';
export const GET_POSTED_BUILDING_APPLICATION =
  '/building/get_posted_building_application';
export const GET_BUILDING_APPLICATION_BY_LAND =
  '/building/get_building_application_by_land';

export const GET_MACHINERY_APPLICATION_EFFECTIVITY_PERIOD =
  '/machinery/get_machinery_application_effectivity_period';
export const GET_MACHINERY_TAX_EFFECTIVITY_PERIOD =
  '/machinery/get_machinery_tax_effectivity_period';

export const GET_MACHINERY_APPLICATION_LOGS =
  '/machinery/get_machinery_application_logs';

export const GET_TRANSACTION_CODES = '/get_transaction_codes';

export const GET_LAND_OWNER = '/get_land_owner';
export const GET_SINGLE_LAND_OWNER = '/get_single_land_owner';
export const GET_BUILDING_OWNER = '/get_building_owner';
export const GET_SINGLE_BUILDING_OWNER = '/get_single_building_owner';
export const GET_MACHINERY_OWNER = '/get_machinery_owner';
export const GET_SINGLE_MACHINERY_OWNER = '/get_single_machinery_owner';

export const GET_PROVINCE = '/get_provinces';
export const GET_MUNICIPALITIES = '/get_municipalities';
export const GET_BARANGAYS = '/get_barangays';
export const GET_DISTRICTS_LIST = 'land/get_districts_list';
export const GET_APPOINTED_PERSONS = 'building/get_appointed_persons';
export const GET_ACTUAL_USE = 'settings/get_actual_use_list';

export const FAAS_URL =
  'api/v1/rpt/administrator/machineries/machinery_applications/{id}/faas';
export const TAX_DECLARATION_URL =
  'api/v1/rpt/administrator/machineries/machinery_applications/{id}/tax_declaration';

export const MACHINERY_APPLICATION_FORM_DATA = {
  rptax_transaction_code_id: '',
  rptax_machinery_owner_id: '',
  machinery_owner_telephone_no: '',
  machinery_owner_tin: '',
  machinery_owner_region_code: '',
  machinery_owner_province_code: '',
  machinery_owner_municipality_code: '',
  machinery_owner_barangay_code: '',
  machinery_owner_address_line: '',
  rptax_machinery_co_owner_ids: [],

  beneficial_user_id: '',
  beneficial_user_telephone_no: '',
  beneficial_user_tin: '',
  beneficial_user_region_code: '',
  beneficial_user_province_code: '',
  beneficial_user_municipality_code: '',
  beneficial_user_barangay_code: '',
  beneficial_user_address_line: '',

  land_tdn: '',
  land_application_id: '',
  land_owner_name: '',
  land_owner_pin: '',
  property_barangay_id: '',
  property_district_id: '',
  property_street: '',
  rptax_building_owner_id: '',
  building_application_pin: '',

  effectivity_of_assessment_reassessment_yr: '',
  effectivity_of_assessment_reassessment_qtr: '',
  registered: '',
  appraised_assessed_at: '',
  recommending_at: '',
  approved_at: '',
  memoranda: '',
};

export const EDIT_MACHINERY_APPLICATION_FORM_DATA = {
  rptax_transaction_code_id: '',
  rptax_machinery_owner_id: '',
  beneficial_user_id: '',
  land_application_id: '',
  building_application_id: '',
  rptax_building_owner_id: null,
  property_street: '',
  appraised_assessed_at: '',
  appraised_assessed_by_id: '',
  approved_at: '',
  approved_by_id: '',
  effectivity_of_assessment_reassessment_yr: '',
  effectivity_of_assessment_reassessment_qtr: '',
  memoranda: '',
  recommending_at: '',
  recommending_by_id: '',
  registered: '',
  rptax_machinery_co_owner_ids: []
};

export const MACHINERY_APPRAISAL_FORM_DATA = {
  machine_id: '',
  brand_and_model: '',
  capacity: '',
  date_acquired: '',
  condition: '',
  economic_life_estimated: '',
  economic_life_remaining: '',
  year_installed: '',
  year_of_initial_operation: '',
  actual_use_id: '',
  no_of_year_used: '',
  original_cost: '',
  rate_of_depreciation: '',
};

export const LAND_PROPERTY_ASSESSMENT_FORM_DATA = {
  rptax_land_classification_id: '',
};

export const SUP_ASSESSMENT_FORM_DATA = {
  pin: '',
  arp_no: '',
  td_no: '',
  total_assessed_value: '',
  previous_owner: '',
  effectivity_of_assessment: '',
  ar_page_no: '',
  recording_person: '',
  date: '',
};

export const TRANSFER_MACHINERY_FORM_DATA = {
  rptax_transaction_code_id: '',
  rptax_machinery_owner_id: '',
  beneficial_user_id: '',
  land_application_id: '',
  building_application_id: '',
  rptax_building_owner_id: '',
  appraised_assessed_at: '',
  appraised_assessed_by_id: '',
  approved_at: '',
  approved_by_id: '',
  effectivity_of_assessment_reassessment_qtr: '',
  effectivity_of_assessment_reassessment_yr: '',
  memoranda: '',
  recommending_at: '',
  recommending_by_id: '',
  registered: '',
  machinery_application_id: '',
};

export const DISPUTE_MACHINERY_FORM_DATA = {
  rptax_transaction_code_id: '',
  memoranda: '',
  machinery_application_id: '',
  tax_effectivity_year: '',
  tax_effectivity_quarter: '',
};

export const PHYSICAL_CHANGE_MACHINERY_FORM_DATA = {
  rptax_transaction_code_id: '',
  memoranda: '',
  machinery_application_id: '',
  tax_effectivity_year: '',
  tax_effectivity_quarter: '',
};

export const DESTRUCTION_MACHINERY_FORM_DATA = {
  rptax_transaction_code_id: '',
  memoranda: '',
  machinery_application_id: '',
  tax_effectivity_year: '',
  tax_effectivity_quarter: '',
};

export const RECLASSIFICATION_MACHINERY_FORM_DATA = {
  rptax_transaction_code_id: '',
  memoranda: '',
  machinery_application_id: '',
  tax_effectivity_year: '',
  tax_effectivity_quarter: '',
};

export const CONSOLIDATION_MACHINERY_FORM_DATA = {
  rptax_transaction_code_id: '',
  memoranda: '',
  registered: '',
  tax_effectivity_year: '',
  tax_effectivity_quarter: '',
  machinery_application_id: [],
};
